module.exports = __webpack_public_path__ + "img/300f.a44c7056.png";